import React from 'react';
import { useError } from '../../../contexts/ErrorContext';
import { Button } from '../buttons/Button';

/**
 * Displays error message, gets user to confirm. Works with Error Context
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
*/
export const ErrorDialog = () => {
    const { 
        error, errorMessage, hideError
    } = useError();

    if (!error) return null;

    return (
        <>
            
            <div className={`h-screen w-screen fixed inset-0 z-[99] transition-opacity opacity-75 bg-black bg-opacity-50 backdrop-filter backdrop-blur-md`}></div>
            
            <div className='fixed flex flex-col top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white p-5 rounded-md border border-black' role="status">
                <h1 className='w-full text-center font-Poppins-Med text-black mt-7'>{errorMessage}</h1>
                
                <div className='m-auto mt-3'>
                    <Button onClick={() => hideError()}>Okay</Button>
                </div>
                
            </div>
        </>
    )
}